export default "__VITE_ASSET__DF1svO46__"